module.exports = __webpack_public_path__ + "static/media/certified.8be2cc49.png";